import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import React from 'react';
import { getTrustedProfileRedirect } from '../../services/projects';

const useStyles = makeStyles((theme) => ({
  box: {
    boxShadow:
      '0px 2px 1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: 16,
    backgroundColor: '#FFF',

    '@media(min-width: 768px)': {
      padding: 24,
      marginBottom: theme.spacing(3),
    },
    cursor: 'pointer',
  },
  marginCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  linkContent: {
    display: 'flex',
    marginTop: 16,
    justifyContent: 'space-between',
  },
  loginImg: {
    maxWidth: 100,

    '@media(min-width: 768px)': {
      maxWidth: '100%',
    },
  },
}));

const TrustedProfile = ({ votesAgreements, displayAgreementsError }) => {
  const classes = useStyles();
  const theme = useTheme();

  const onTrusted = async () => {
    const {
      data: { url },
    } = await getTrustedProfileRedirect(window.location.pathname);
    window.location.replace(url);
  };

  const handleClick = () => {
    const allSelected = Object.values(votesAgreements).every((v) => v === true);
    if (allSelected) {
      displayAgreementsError(!allSelected);
      onTrusted();
    } else {
      displayAgreementsError(!allSelected);
    }
  };

  return (
    <Grid item xs={12} lg={7} className={classes.marginCenter}>
      <Box className={classes.box} onClick={handleClick}>
        <Typography style={{ color: theme.palette.text.primary }}>
          Lub zweryfikuj swoją tożsamość poprzez
        </Typography>
        <div className={classes.linkContent}>
          <img
            alt='login'
            className={classes.loginImg}
            src='/static/images/Votes/login.png'
            title='login'
          />
        </div>
      </Box>
    </Grid>
  );
};

export default TrustedProfile;
